
import { CollectionDetailEntity, EMPTY_COLLECTION_DETAIL_ENTITY } from "domain/entity/Collection/CollectionDetailEntity";
import { CollectionHeaderEntity, EMPTY_COLLECTION_HDR_ENTITY } from "domain/entity/Collection/CollectionHeaderEntity";
import { CollectionHeaderSearchCriteria, EMPTY_COLLECTION_HDR_SEARCH_CRITERIA } from "domain/entity/Collection/CollectionHeaderSearchCriteria";
import { CompanyCodeEntity } from "domain/entity/Company/CompanyCodeEntity";
import { DropdownProps } from "../DropdownProps";

export interface CollectionDropdownOptions {

    companyCodeDropdownOptions: DropdownProps[],
    bankCodeDropdownOptions: DropdownProps[],
    paymentModeDropdownOptions: DropdownProps[],
    payeeDropdownOptions: DropdownProps[],
}


export interface CollectionModel {
    isLoading: boolean,
    collectionHdrList: CollectionHeaderEntity[],
    collectionDtlList: CollectionDetailEntity[],
    isShowEditPanel: boolean,
    isShowSearchPanel: boolean,
    isShowDetailPanel: boolean,
    isEdit: boolean,
    isAdd: boolean,
    dynamicOptions: CollectionDropdownOptions,
    selectedRows: CollectionHeaderEntity[],
    currentRow: CollectionHeaderEntity,
    selectedDtlRows: CollectionDetailEntity[],
    currentDtlRow: CollectionDetailEntity,
    currentDtlEditRow: CollectionDetailEntity,
    searchCriteria: CollectionHeaderSearchCriteria,
    forceRefresh: boolean,
    draftInvoiceNos: string,
    totalInvAmt: number,
    unPaidHdrList: number[],
    payeeNameList: CompanyCodeEntity[],
    lastEditRowId: number[],
    observation: string,
    isEditingHdr: boolean,
    isReselectRows: boolean,
    tempSelectedRows: CollectionHeaderEntity[],
    isSearchLoading: boolean,
    allFormState?: { [x: string]: string },
    currentDtlAddRowList: CollectionDetailEntity[],
}

export const EMPTY_COLLECTION_MODEL: CollectionModel = {
    isLoading: false,
    collectionHdrList: [],
    isShowEditPanel: false,
    isShowSearchPanel: false,
    isEdit: false,
    isAdd: false,
    selectedRows: [],
    currentRow: { ...EMPTY_COLLECTION_HDR_ENTITY },
    searchCriteria: { ...EMPTY_COLLECTION_HDR_SEARCH_CRITERIA },
    forceRefresh: false,
    dynamicOptions: {
        companyCodeDropdownOptions: [],
        bankCodeDropdownOptions: [],
        paymentModeDropdownOptions: [],
        payeeDropdownOptions: []
    },
    isShowDetailPanel: false,
    collectionDtlList: [],
    selectedDtlRows: [],
    currentDtlRow: { ...EMPTY_COLLECTION_DETAIL_ENTITY },
    currentDtlEditRow: { ...EMPTY_COLLECTION_DETAIL_ENTITY },
    draftInvoiceNos: "",
    totalInvAmt: 0,
    payeeNameList: [],
    unPaidHdrList: [],
    lastEditRowId: [],
    observation: "",
    isEditingHdr: false,
    isReselectRows: false,
    tempSelectedRows: [],
    isSearchLoading: true,
    currentDtlAddRowList: [],
}